module.exports = __webpack_public_path__ + "img/RCT00.9ef6a020.svg";